import { Icon } from '@iconify/react'
import bell from '@iconify/icons-eva/bell-outline'

export const NotificationsIcon = () => {
  return <Icon icon={bell} width={20} height={20} color="#000000" />
}

export default NotificationsIcon
